'use strict';

var theme_palette_light = require('./light.js');
require('../../variables-1eb6495a.js');

const getPalette = (variant) => {
    switch (variant) {
        case "light":
        default:
            return theme_palette_light;
    }
};

module.exports = getPalette;
